import {
    GET_AREAS,
    GET_AREAS_SUCCESS,
    GET_AREAS_FAIL,
    ADD_AREA_SUCCESS,
    ADD_AREA_FAIL,
    UPDATE_AREA_SUCCESS,
    UPDATE_AREA_FAIL,
    DELETE_AREA_SUCCESS,
    DELETE_AREA_FAIL,
  } from "./actionTypes";
  
  const initialState = {
    areas: [],
    loading: false,
    error: null,
  };
  
  const areaReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_AREAS:
        return {
          ...state,
          loading: true,
        };
      case GET_AREAS_SUCCESS:
        return {
          ...state,
          loading: false,
          areas: action.payload,
          error: null,
        };
      case GET_AREAS_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case ADD_AREA_SUCCESS:
        return {
          ...state,
          areas: {
            ...state.areas,
            Data: [action.payload, ...(state.areas?.Data || [])],
          },
          error: null,
        };
      case ADD_AREA_FAIL:
        return { ...state, error: action.payload };
  
      case UPDATE_AREA_SUCCESS:
        return {
          ...state,
          areas: {
            ...state.areas,
            Data: state.areas?.Data?.map((a) =>
              a.areaId === action.payload.areaId ? action.payload : a
            ),
          },
          error: null,
        };
      case UPDATE_AREA_FAIL:
        return { ...state, error: action.payload };
  
      case DELETE_AREA_SUCCESS:
        return {
          ...state,
          areas: {
            ...state.areas,
            Data: state.areas?.Data?.filter((a) => a.areaId !== action.payload),
          },
          error: null,
        };
      case DELETE_AREA_FAIL:
        return { ...state, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export default areaReducer;
  